var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "#EBF5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9426 33.5949C22.6857 31.3532 22.6857 27.7028 24.9426 25.4441C27.1991 23.1854 30.8523 23.1854 33.1086 25.4441C35.3655 27.6861 35.3655 31.3368 33.1086 33.5949L29.4359 37.2672C29.2093 37.4938 28.8419 37.4938 28.6153 37.2672L24.9426 33.5949ZM26.5799 31.9758C27.9404 33.3182 30.1243 33.3182 31.4665 31.9758C32.8264 30.6137 32.8264 28.4272 31.4665 27.0848C30.1053 25.7423 27.9217 25.7229 26.5799 27.0848C25.239 28.4469 25.239 30.6333 26.5799 31.9758Z",
    fill: "#0A57FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.25 16.5H17.75C17.0596 16.5 16.5 17.0596 16.5 17.75V40.25C16.5 40.9404 17.0596 41.5 17.75 41.5H37.75C39.8211 41.5 41.5 39.8211 41.5 37.75V17.75C41.5 17.0596 40.9404 16.5 40.25 16.5ZM18.375 18.375V39.625H37.75C38.7855 39.625 39.625 38.7855 39.625 37.75V18.375H31.5V20.4887C31.5 20.9533 31.0111 21.2555 30.5955 21.0477L29.2795 20.3898C29.1036 20.3018 28.8964 20.3018 28.7205 20.3898L27.4045 21.0477C26.9889 21.2555 26.5 20.9533 26.5 20.4887V18.375H18.375Z",
    fill: "#0A57FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVIcon2);
export default __webpack_public_path__ + "static/media/v-icon2.a116c1f8bf34975c2cd6bf47236f6a3c.svg";
export { ForwardRef as ReactComponent };